export default __webpack_public_path__ + "static/ebay-66d17aa632105bad0c02ec766e74efd6.png";